import { SET_ALL_PAGES } from "./actionTypes";

export const setAllPagesAction = (pages: any) => {
    return {
        type: SET_ALL_PAGES,
        payload: pages
    };
};
